"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextApiErrorBoundary = void 0;
var react_1 = __importDefault(require("react"));
var error_1 = require("../next-api-error/error");
var error_boundary_1 = require("./error-boundary");
var error_overlay_1 = require("./error-overlay");
/**
 * This will catch any NextApiError that is thrown (outside of event handlers) and render a nice error message to the
 * user. This should wrap your application.
 */
function NextApiErrorBoundary(props) {
    var children = props.children, onError = props.onError;
    return (react_1.default.createElement(error_boundary_1.ErrorBoundary, { onError: onError }, function (error) {
        if (error && (0, error_1.isNextApiErrorLike)(error)) {
            return react_1.default.createElement(error_overlay_1.ErrorOverlay, { error: error });
        }
        return children;
    }));
}
exports.NextApiErrorBoundary = NextApiErrorBoundary;
